import {RestResource} from '../../rest'
import {ASSESSMENT_SERVER,COMMON_SERVER,PUE_SERVER} from '../../server'
import {athubAxios} from '../../../util'
import axios from 'axios';


//根据数据中心开始结束时间查询对应的PUE记录
function queryPueBySysRooms(array,searchStartDate,searchEndDate){
    var userAuthInfo = {
        "token": localStorage.getItem("token"),
        "appId": localStorage.getItem("appId"),
        "authorg": localStorage.getItem("authorg"),
        "authsites": localStorage.getItem("authsites"),
        "defsite": localStorage.getItem("defsite"),
        "realname": "billing-219-oam",
        "userId": localStorage.getItem("userid"),
        "userName": localStorage.getItem("username"),
        "authScope": {
            "userId": localStorage.getItem("userid"),
            "sites": localStorage.getItem("authsites"),
            "orgs": localStorage.getItem("authorg")
        },
        "authorizes": ["billing.ui.RBSC.WO.RSC", "billing.be.RBSC.WO.new", "billing.be.RBSC.WO.RSC", "billing.ui.RBSC.WO.save", "billing.ui.RBSC.WO.view", "billing.ui.RBSC.WO.commit", "billing.ui.RBSC.WO.new", "menu.billing3", "billing.be.RBSC.WO.viewAll", "billing.ui.RBSC.viewAllCustomer", "billing.be.RBSC.viewAllCustomer"]
    };
    var userAuthInfoString = JSON.stringify( userAuthInfo );
    var userAuthInfoStringURIencoded = encodeURIComponent( userAuthInfoString );
    return new Promise((resolve, reject) => {
            axios.post(`${PUE_SERVER}/PUE/daily/list`, {
                'in_roomId':array,
                'eq_recordSource': 0,
                'gt_tsdate':searchStartDate,
                'lt_tsdate':searchEndDate,
            }
            ,{
                headers:{
                    'User-Auth-Info':userAuthInfoStringURIencoded}
            }
        ).then((responseBody) => {
            if (responseBody.status == 200) {
        resolve(responseBody.data.data);
    }
}).catch(error => {
        reject(error);
});
});
}


export {
    queryPueBySysRooms,
}